import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { InfoPage } from 'components/common/Layout/InfoPage/InfoPage';
import ModalComponent from 'components/utils/ModalComponent';

import { toggleSpinner } from 'actions/appAction';

import { resolveArguments } from 'helpers/utils';

import { useExtra, usePageMessages } from 'hooks/selectors';

const IncreaseLowRiskLimitModal = (props) => {
    const { notNowButton, continueButton, increaseLimitPurpleTitle, increaseLimitTitle, increaseLimitSubTitle, increaseLimitSubCountryName } =
        usePageMessages();
    const { increaseLimitUrl } = useExtra();

    const text = (
        <>
            <span>{increaseLimitPurpleTitle}</span>
            <br />
            {increaseLimitTitle}
        </>
    );

    return (
        <ModalComponent isVerticalCentered canCloseModal={false}>
            <InfoPage
                insideModalComponent
                iconName="bank-building-card-thin"
                iconColor="purple"
                topButtonCaption={notNowButton}
                topButtonType={'link'}
                topButtonLink={props.notNowLink}
                topButtonOnClick={(e) => {
                    if (!props.notNowLink) {
                        e?.preventDefault();
                        props.modalRef?.current?.close();
                    }
                }}
                primaryButtonCaption={continueButton}
                primaryButtonType={'link'}
                primaryButtonLink={increaseLimitUrl}
                headerText={text}
                secondaryText={resolveArguments(increaseLimitSubTitle, [increaseLimitSubCountryName])}
                primaryButtonOnClick={() => {
                    props.toggleSpinner(true);
                }}
            />
        </ModalComponent>
    );
};
IncreaseLowRiskLimitModal.propTypes = {
    modalRef: PropTypes.object.isRequired,
    notNowLink: PropTypes.string,
};

export default connect(null, { toggleSpinner })(IncreaseLowRiskLimitModal);
